<template>
    <v-card outlined class="d-flex flex-column" v-bind="{ height, loading }">
        <chat-count />
        <v-divider />
        <chat-messages />
        <v-divider />
        <v-card-actions class="pa-0">
            <chat-input />
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ChatCount from "./chat/chat-count.vue";
import ChatInput from "./chat/chat-input.vue";
import ChatMessages from "./chat/chat-messages.vue";

export default {
    components: {
        ChatCount,
        ChatInput,
        ChatMessages,
    },
    computed: {
        ...mapState("lecture/chat", ["loading", "height"]),
    },
    methods: {
        ...mapActions("lecture/chat", ["init", "exit"]),
    },
    mounted() {
        if (!this.isInitiated) this.init();
    },
    beforeDestroy() {
        this.exit();
    },
};
</script>

<style>
</style>